import { asyncToGenerator as _asyncToGenerator, regeneratorRuntime as _regeneratorRuntime, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import util from './authServiceUtil.js';

var defaultTokenValid = function defaultTokenValid(err) {
  return !(err.networkError && err.networkError.statusCode === 401);
};
// If we get CORS error from the HA Proxy, i.e. networkError without statusCode, then retry getting an auth token
var corsError = function corsError(err) {
  var _err$message;
  return !!((_err$message = err.message) !== null && _err$message !== void 0 && _err$message.includes('Network error') && 'networkError' in err && !err.networkError.statusCode);
};
var unauthorized = function unauthorized(err) {
  var _err$response, _err$response2, _err$response3, _err$response3$data;
  return (err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.status) === 401 || (err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : _err$response2.status) === 400 && (err === null || err === void 0 ? void 0 : (_err$response3 = err.response) === null || _err$response3 === void 0 ? void 0 : (_err$response3$data = _err$response3.data) === null || _err$response3$data === void 0 ? void 0 : _err$response3$data.errorCode) === 'AUT_00003';
};
var refreshToken = function refreshToken(onLogout) {
  var isRefreshing = false;
  var postponedQueries = [];
  return function (refreshable) {
    var tokenValid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultTokenValid;
    return function (context) {
      return refreshable(context)["catch"](function (err) {
        if (tokenValid(err) && !corsError(err)) {
          throw err; // let somebody else handle the problem since the token is valid
        }

        if (isRefreshing) {
          return new Promise(function (resolve, reject) {
            postponedQueries.push({
              resolve: resolve,
              reject: reject,
              postponed: refreshable,
              argument: context.arguments
            });
          });
        }
        isRefreshing = true;
        postponedQueries = [];
        return util.refreshAuthToken(context.url)["catch"]( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return util.login(context.url);
                case 3:
                  _context.next = 12;
                  break;
                case 5:
                  _context.prev = 5;
                  _context.t0 = _context["catch"](0);
                  if (!unauthorized(_context.t0)) {
                    _context.next = 11;
                    break;
                  }
                  onLogout();
                  _context.next = 12;
                  break;
                case 11:
                  throw _context.t0;
                case 12:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 5]]);
        }))).then(function () {
          postponedQueries.forEach(function (_ref2) {
            var postponed = _ref2.postponed,
              resolve = _ref2.resolve,
              reject = _ref2.reject,
              argument = _ref2.argument;
            return postponed(_objectSpread2(_objectSpread2({}, context), {}, {
              arguments: argument
            })).then(resolve)["catch"](reject);
          });
          return refreshable(context);
        })["finally"](function () {
          isRefreshing = false;
        });
      });
    };
  };
};

export { refreshToken };
